const CardContainer = ({
  children,
  innerClassNames = "grid md:gap-[16px] gap-[10px]",
  id,
}: {
  children: React.ReactNode;
  innerClassNames?: string;
  id: string;
}) => {
  return (
    <div
      id={id}
      className="max-w-[calc(100vw-32px)] rounded-[2px] bg-[#FDFDFB] px-[16px] pt-[24px] pb-[24px] md:max-w-[min(calc(100vw-48px),960px)] md:px-[34px] md:pt-[34px] md:pb-[42px] lg:max-w-[1000px]"
    >
      <div className={innerClassNames}>{children}</div>
    </div>
  );
};

export default CardContainer;
